import { useContext, useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { AlternateAliasContext } from "../../context/AlternateAliasContext";

export const useAlternateAliasInfo = () => {
    const [state, setState] = useState({ isLoaded: false, error: null });
    const { authState } = useOktaAuth();
    const { aliasModule, setAliasModule } = useContext(AlternateAliasContext);

    useEffect(() => {
        const fetchAliasInfo = async () => {
            try {
                const readUrl = new URL(`${process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT}/alias`);
                readUrl.searchParams.append("id", aliasModule.upn);

                const response = await fetch(readUrl.toString(), {
                    method: "GET",
                    headers: {
                        Authorization: authState.accessToken.accessToken,
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                });

                if (!response.ok) {
                    let message = `Request failed with status ${response.status}`;
                    try {
                        const errorData = await response.json();
                        message =
                            errorData?.error?.message ||
                            errorData?.message ||
                            `${response.status} ${response.statusText}`;
                    } catch {
                        // response body wasn't JSON — use the status-based message
                    }
                    throw new Error(message);
                }

                const result = await response.json();
                setAliasModule((prev) => ({ ...prev, data: result, isLoaded: true }));
                setState((prev) => ({ ...prev, isLoaded: true }));
            } catch (error) {
                setState({ isLoaded: true, error });
            }
        };

        fetchAliasInfo();
    }, [aliasModule.upn, authState.accessToken.accessToken, setAliasModule]);

    return state;
};
